import styled from 'styled-components';

export const Container = styled.div`

`;

export const Input = styled.input`
  display: inline-block;
  height: 2rem;
  width: 5rem;
  text-align: center;
  border: 0;
  padding: 0 0.4rem;


  /*Remove spinner from 'number type*/
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type=number] {
    -moz-appearance: textfield;
  }
`;

export const Button = styled.button`
  display: inline-block;
  height: 2rem;
  width: 2rem;
  border: 0;
  background-color: var(--color-primary);
  color: #FFF;

  &:hover {
    cursor: pointer;
    background-color: var(--color-primary-dark);
  }
`;
